// src/providers/AppBridgeProvider.tsx
import { createApp, ClientApplication } from '@shopify/app-bridge';
import { useEffect, useState } from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {AppDispatch} from "~/store";
import {fetchApp} from "~/store/appSlice.ts";
import {Flex, Spinner, Text, VStack} from "@chakra-ui/react";
import useAuthentication from "~/hooks/useAuthentication.ts";

interface AppBridgeProviderProps {
    children: React.ReactNode;
}

export function AppBridgeProvider({ children }: AppBridgeProviderProps) {
    const [app, setApp] = useState<ClientApplication<any> | null>(null);
    const dispatch = useDispatch<AppDispatch>();
    const [isLoading, setIsLoading] = useState(true);
    const {getShopifySession} = useAuthentication();
    const session = getShopifySession();
    const navigate = useNavigate();
    if(!session) {
        navigate('/login');
        return;
    }
    const public_id = session.public_id;

    useEffect(() => {
        const initializeApp = async () => {
            const host = new URLSearchParams(window.location.search).get('host');
            const shop = new URLSearchParams(window.location.search).get('shop');
            if (!host || !shop || !public_id) {
                setIsLoading(false);
                return;
            }

            try {
                const appDetails = await dispatch(fetchApp(public_id)).unwrap();
                console.log('APP DETAILS LOADED')
                console.log(appDetails)
                // window.location.hostname !== 'localhost'
                const appInstance = createApp({
                    apiKey: appDetails.client_id,
                    host: host,
                    forceRedirect: false
                });

                setApp(appInstance);
                // Store app instance globally
                window.app = appInstance;
            } catch (error) {
                console.error('Failed to initialize App Bridge:', error);
            } finally {
                setIsLoading(false);
            }
        };

        initializeApp();
    }, [public_id]);

    if (isLoading) {
        return (
            <Flex
                minH="100vh"
                bg="gray.800"
                alignItems="center"
                justifyContent="center"
            >
                <VStack spacing={6}>
                    <Spinner
                        size="xl"
                        thickness="4px"
                        color="blue.500"
                        emptyColor="gray.700"
                    />
                    <Text color="gray.300" fontSize="lg">
                        Connecting to Shopify App Bridge Please Wait...
                    </Text>
                </VStack>
            </Flex>
        )
    }

    if (!app) {
        return children; // Return children for non-Shopify contexts
    }

    return <>{children}</>;
}